import React from "react";
import { Helmet } from "react-helmet";

import Cta from "../components/cta";
import Header from "../components/header";
import ImageCarousel from "../components/imageCarousel";
import { Container, Section } from "../components/layout";
import PageIntro from "../components/pageIntro";
import SectionLabel from "../components/sectionLabel";
import StatSection from "../components/statSection";
import VideoContainer from "../components/videoContainer";
import HeaderImage from "../images/header-images/living-in-stl.jpg";
import HeaderMobile from "../images/header-images/living-in-stl-mobile.jpg";
import SaintLouis1 from "../images/Living-in-STL_1.jpg";
import SaintLouis2 from "../images/Living-in-STL_2.jpg";
import SaintLouis3 from "../images/Living-in-STL_3.jpg";
import SaintLouis4 from "../images/Living-in-STL_4.jpg";

export default function SaintLouis() {
  return (
    <div>
      <Helmet htmlAttributes={{lang: 'en'}}>
          <meta charSet="utf-8" />
          <title>Living in St. Louis - International Viewbook - Maryville University</title>
      </Helmet>
      <Header image={HeaderImage} mobileImage={HeaderMobile} />
      <Section>
        <Container>
          <PageIntro
            title="Living in St. Louis"
            subtitle="What’s so great about living in St. Louis?
        Everything.
        "
            text={
              "“One of the best places to live in the country.” That’s what U.S. News and World Reports says about St. Louis. And we totally agree. It’s a historic city full of vibrant, unique neighborhoods, each with its own vibe. Plus, St. Louis residents are friendly, and a little quirky, and take an enormous amount of pride in their city."
            }
          />
        </Container>
      </Section>
      <ImageCarousel
        images={[
          {src: SaintLouis1, alt: "Students laughing in a ball pit at St. Louis' City Museum"},
          {src: SaintLouis2, alt: "Students walking around outside in St. Louis"},
          {src: SaintLouis3, alt: "Students looking at architecture in the Lafayette Square neighborhood in St. Louis"},
          {src: SaintLouis4, alt: "Students exploring a local St. Louis park"}
        ]}
      />
      <StatSection
        stats={[
          {
            figure: "1764",
            caption: "Year Founded",
          },
          {
            figure: (
              <span>
                1<sup className="-top-4 text-lg">st</sup>
              </span>
            ),
            caption: "American city to host Olympics",
          },
          {
            figure: "2.8MM",
            caption: "Metro Area Population",
          },
          {
            figure: "630'",
            caption: "Height of the Gateway Arch",
          },
        ]}
      />
      <SectionLabel label={"Check out some must visit places"} />
      <VideoContainer
        title={"Things to do in Saint Louis"}
        embedUrl="https://www.youtube.com/embed/U56xuIwcM48"
      />
      <Cta />
    </div>
  );
}
